var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Nuxt'),_vm._v(" "),_c('style',{tag:"component"},[_vm._v("\n    :root {\n      --primary: "+_vm._s(_vm.network.primary_color)+";\n      --secondary: "+_vm._s(_vm.network.secondary_color)+";\n    }\n    "+_vm._s(_vm.network.custom_css)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }